
















































import request from '@/graphql/request';
import IDevice from '@/interfaces/device';
import CreateDeviceMutation from '@/graphql/mutations/createDevice.gql';
import RefreshDeviceTokenMutation from '@/graphql/mutations/refreshDeviceToken.gql';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class AddDevice extends Vue {
  public nickname = '';
  public deviceTag = '';
  public errorMessage = '';

  public createDevice() {
    const nickname = this.nickname;
    const deviceTag = this.deviceTag;

    request(CreateDeviceMutation as any, { deviceTag, nickname })
      .then(({ data, errors }) => {
        if (errors && errors.length && errors.length > 0) {
          throw new Error();
        }
        const deviceId = data.createDevice;
        // request(RefreshDeviceTokenMutation as any, { deviceId }).then(
        //   ({ data, errors }) => {
        //     if (errors && errors.length && errors.length > 0) {
        //       throw new Error();
        //     }
        //     this.nickname = '';
        //     this.deviceTag = '';
        //     this.$emit('deviceCreated', deviceId);
        //   }
        // );
        this.$emit('deviceCreated', deviceId);
      })
      .catch(error => {
        this.errorMessage = 'Adding device failed.';
      });
  }
}
